import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage as setPageAction } from "../../../actions/advancedListActions";
import { getBybetjentGrupper as getBybetjentGrupperAction } from "../../../actions/bybetjentgrupperAction";
import { getEttersendelser as getEttersendelserAction } from "../../../actions/ettersendelserActions";
import {
  handleChange as handleChangeAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getIleggelsestyper as getIleggelsestyperAction } from "../../../actions/ileggelsestyperActions";
import FilterForm from "./FilterForm";

import { getSelectOptions } from "../../../selectors/selectOptionsSelector";

import { toIsoString } from "../../../utils/date";
import * as inputValidation from "../../../utils/inputValidationUtils";
import { IsValidated } from "../../../utils/validationUtils";

import { replaceWhitespacesWithEmptyStrings } from "../../../utils/sanitizationUtils";
import "./EttersendelserFilterContainer.css";

const FORM_KEY = "ETTERSENDELSER_FILTER_FORM";

const rules = {
  ileggelsesnummer: "isPositiveInteger",
  tjenestenummer: "isPositiveInteger",
};

export default function EttersendelserFilterContainer() {
  const dispatch = useDispatch();
  const ettersendelserFilterForm = useSelector(
    (state) => state.forms.ettersendelserFilterForm,
  );
  const ileggelsestyper = useSelector((state) =>
    getSelectOptions(state, "ileggelsestyper", "navn", "id"),
  );
  const betjentgrupper = useSelector((state) =>
    getSelectOptions(state, "betjentgrupper", "navn", "id"),
  );
  const ettersendelser = useSelector((state) => state.ettersendelser);

  const [showSokSpinner, setShowSokSpinner] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getIleggelsestyperAction());
    dispatch(getBybetjentGrupperAction());
  }, []);

  const dispatchChange = (name, value) =>
    dispatch(handleChangeAction(FORM_KEY, name, value));

  const handleChange = (e) => {
    dispatchChange(e.target.name, e.target.value);
  };

  const handleBlur = (e) => {
    if (
      e.target.name === "ileggelsesnummer" ||
      e.target.name === "tjenestenummer"
    ) {
      dispatchChange(
        e.target.name,
        replaceWhitespacesWithEmptyStrings(e.target.value),
      );
    }
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction(FORM_KEY));
  };

  const isValid = () => {
    const propsAsFakeState = {
      ileggelsesnummer: ettersendelserFilterForm.ileggelsesnummer,
      tjenestenummer: ettersendelserFilterForm.tjenestenummer,
      validationError: {
        ileggelsesnummer:
          ettersendelserFilterForm.validationError.ileggelsesnummer,
        tjenestenummer: ettersendelserFilterForm.validationError.tjenestenummer,
      },
    };
    const { isValid: formIsValid, validationError } = IsValidated(
      propsAsFakeState,
      rules,
    );
    dispatchChange(
      "validationError.ileggelsesnummer",
      validationError.ileggelsesnummer,
    );
    dispatchChange(
      "validationError.tjenestenummer",
      validationError.tjenestenummer,
    );

    const fraDateTimeTilDateTimeValid =
      inputValidation.fraDateTimeTilDateTimeValidation(
        ettersendelserFilterForm,
        dispatchChange,
      );

    return formIsValid && fraDateTimeTilDateTimeValid;
  };

  const getEttersendelserFilter = () => {
    const { fraTid, tilTid, status, ...filter } = ettersendelserFilterForm;
    return {
      ...filter,
      fraDato: filter.fraDato && toIsoString(filter.fraDato),
      tilDato: filter.tilDato && toIsoString(filter.tilDato),
      isElsparksykkelGebyr: false,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid()) {
      const params = getEttersendelserFilter();
      setShowSokSpinner(true);
      const page = 1;
      dispatch(getEttersendelserAction(params, page, ettersendelser.count))
        .then(() => {
          setShowSokSpinner(false);
          dispatch(setPageAction("ettersendelser", page));
        })
        .catch(() => setShowSokSpinner(false));
    }
  };

  return (
    <div className="ettersendelse-filter-container">
      <h1>Søk etter ettersendelser</h1>
      <FilterForm
        showSokSpinner={showSokSpinner}
        ettersendelseFilterFormState={ettersendelserFilterForm}
        betjentgrupper={betjentgrupper}
        ileggelsestyper={ileggelsestyper}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleChangeToInitState={handleChangeToInitState}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}
